export const FRIENDSHIP_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
};

export const FRIEND_SEARCH_STATUS = {
  NONE: 'none',
  ACCEPTED: 'accepted',
  REQUEST_SENT: 'request_sent',
  REQUEST_RECEIVED: 'request_received',
};

export const DEBT_STATUS = {
  UNPAID: 'unpaid',
  PAID: 'paid',
};